import React from "react";
import { Result, Button } from "antd";

class RouteErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Route render error:", error, info.componentStack);
  }

  componentDidUpdate(prevProps) {
    // ถ้าเปลี่ยนหน้า (path เปลี่ยน) ให้ลอง render ใหม่โดยไม่ต้อง refresh
    if (this.state.hasError && prevProps.routeKey !== this.props.routeKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="เกิดข้อผิดพลาดในการแสดงผลหน้านี้"
          subTitle="กรุณาลองเลือกเมนูอีกครั้ง หรือรีเฟรชหน้าเว็บหากยังพบปัญหา"
          extra={
            <Button
              type="primary"
              onClick={() => this.setState({ hasError: false })}
            >
              ลองใหม่
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}

export default RouteErrorBoundary;
